import {
  ConfirmPlanDialogProps,
  FeedbackPlanDialogProps,
  PlanActionMode,
  ResultPlanDialogProps,
} from '@aibees/shared/definition';

export interface SubscriptionManagerProps {
  className?: string;
  actionMode: PlanActionMode | null;
  triggerElement: React.ReactElement;
}

export enum SubscriptionModalType {
  WATCH_VIDEO = 'WATCH_VIDEO_DOWNGRADE_FREE',
  CONFIRM_MODAL = 'CONFIRM_DOWNGRADE_FREE',
  COLLECT_FEEDBACK = 'COLLECT_FEEDBACK',
  SHOW_RESULT = 'SHOW_RESULT',
}

export interface SubscriptionFlow {
  activeModal: SubscriptionModalType | null;
  closeModal: () => void;
  onStart: () => void;
  videoDialogProps?: ConfirmPlanDialogProps;
  confirmDialogProps?: ConfirmPlanDialogProps;
  feedbackDialogProps?: FeedbackPlanDialogProps;
  resultDialogProps?: ResultPlanDialogProps;
}
